<div [class]="isLocal ? 'loading-local' : 'loading'">
  <mat-spinner [diameter]="70" class="preloader"></mat-spinner>
</div>
